import { Box, Modal } from '@mui/material';
import React from 'react';

type ImageModalProps = {
  open: boolean;
  src: string;
  onClose: () => void;
};

const modalStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50vw',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
};

const ImageModal: React.FC<ImageModalProps> = ({ open, src, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="image-modal-title"
      aria-describedby="image-modal-description"
    >
      <Box sx={modalStyle}>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
          <img
            src={src}
            alt="Preview"
            style={{ maxWidth: '100%', maxHeight: '100%' }}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ImageModal;
